import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';

import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SeeMuch');
    const getParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams: any = {};
        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');

        if (!!utmSource) {
            utmParams.utm_source = utmSource;
        }

        if (!!utmMedium) {
            utmParams.utm_medium = utmMedium;
        }

        if (!!utmCampaign) {
            utmParams.utm_campaign = utmCampaign;
        }
        return utmParams;
    };

    const openPage = () => {
        const params: any = getParams();
        let baseUrl = 'https://energy-sit.ecoflow.work/us/en/na/locationInfo';

        if (process.env.NEXT_PUBLIC_MODY === 'prd') {
            baseUrl = 'https://energy.ecoflow.com/us/en/na/locationInfo';
        }

        // 创建 URLSearchParams 实例并自动处理 params 中的字段
        const urlParams = new URLSearchParams(params);

        // 拼接参数到 URL
        const finalUrl = `${baseUrl}?${urlParams.toString()}`;

        window.open(finalUrl);
    };

    return (
        <div className={`${styles.comp}`} id="SeeMuch">
            <EcoSectionCommon title={t('title')} desc={t('desc')} labelColor="#3F68E0" />
            <a className="link" onClick={openPage}>
                {t('btn')}
            </a>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1751873272043/caculator-pc.png"
                h5="https://websiteoss.ecoflow.com/upload/image/1751873328559/caculator-h5.png"
            />
        </div>
    );
}
